export const START_LOAD = 'racingBracket/START_LOAD';
export const FINISH_LOAD = 'racingBracket/FINISH_LOAD';

const initialState = {
    loading:false,
    racingBracket:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, racingBracket:action.payload};
        default: return state;
    }
}